import { useSetAtom } from 'jotai'
import { dialogAtom } from './atom'
import { DialogType } from './dialogTypes'
import type { DialogDataRequired } from './types'

export const useDialog = () => {
  const setDialog = useSetAtom(dialogAtom)

  const openDialog = <T extends DialogType>(
    dialogType: T,
    ...dialogData: DialogDataRequired<T>
  ) => {
    setDialog({
      type: dialogType,
      data: dialogData.length > 0 ? dialogData[0] : undefined,
    })
  }
  const closeDialog = () => {
    setDialog({ type: null, data: undefined })
  }

  return {
    openDialog,
    closeDialog,
  }
}
